import Winter from "../../../entities/Winter/ui/Winter";

const WinterPage = () => {
    return (
        <main>
          <Winter/>
        </main>
      );
}
 
export default WinterPage;